<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div id="filters">
          <div class="search col-lg-12 col-md-12">
            <div class="col-lg-3 col-md-3 m-t-sm">
              <v-select
                placeholder="Clients"
                :options="f.clients"
                label="name"
                multiple
                v-model="multiFilters['clients']"
              ></v-select>
            </div>
            <div class="col-lg-3 col-md-3 m-t-sm">
              <div class="display-flex">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input">Period</div>
                <input type="date" v-model="filters['dateFrom']" min="0" name="" placeholder="from" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
                <input type="date" v-model="filters['dateTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 m-t-sm">
              <v-select placeholder="Group by" :options="groupBy" v-model="filters['groupBy']" index="id"></v-select>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 m-t-sm">
            <div class="col-lg-3 col-md-3">
              <button class="btn btn-primary btn-xs" @click="loadReport">Generate</button>
              <button class="btn btn-success btn-xs" @click="loadReport(true)"><i class="fa fa-download"></i> Download</button>
            </div>
          </div>
        </div>
        <div class="search col-lg-12 col-md-12">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Group</th>
              <th>Client</th>
              <th>Count</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, i) in results" :key="'results-' + i">
              <td>
                <span v-if="row.group.name">{{ row.group.name }}</span>
                <span v-else>{{ row.group.domain }}</span>
              </td>
              <td>{{ row.client.name }}</td>
              <td>{{ row.count }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Browser, Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      results: [],
      filters: {},
      multiFilters: {},
      groupBy: [
        {label: 'Pbn', id: 'pbn'},
        {label: 'Client', id: 'client'}
        // {label: 'Group', id: 'group'}
      ]
    }
  },
  mounted () {
    document.title = 'Links Built :: Reports :: PBN360 by Aphex Media'
  },
  mixins: [Query, Browser],
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    loadReport (csv = false) {
      axios.get('/pbn/report/links?' + this.buildQuery(this.filters, this.multiFilters), {
        headers: {
          'Accept': csv === true ? 'text/csv' : 'application/json'
        }
      }).then(r => {
        if (csv === true) {
          this.downloadFile('link-building-report.csv', r.data.data)
        } else {
          this.results = r.data.data
        }
      }).catch(e => {
        this.$toastr.error(e, 'Bad luck')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/LinksBuilt.vue